<template>
  <div id="Main" class="" style="height:calc(100vh);">
    <div class="col-12 fixed-t" ref="index_head">
      <div class="col-12 h20 color-white">
        <div class="col-12 h20 bg-color-primary" style="position: relative;">
          <div class="col-12 lh40 pl10 pr10">
            <div class="col-3 f26" @click="go_news()" :class="notify_count > 0 ? 'shake':''"><i class="iconfont icon-notification"></i></div>
            <div class="col-6 t-c"><span class="f24 fw">POS</span>.com.ve</div>
            <div class="col-3 f26 t-r" @click="app_select()" v-if="$store.state.account.account_grade >= 50"><i class="iconfont icon-modular"></i></div>
            <div class="col-3 color-primary t-r" v-else>-</div>
          </div>
          <div class="col-12 pl10 pr10 h10">
            <div class="col-3 h8 r5 t-c-v"><img src="../assets/store_logo.png" class="r5" style="height:80%"></div>
            <div class="col-9 pt10">
              <div class="col-12 f14 mb2"> {{ $store.state.pos.license_type }}-{{ $store.state.pos.license }} </div>
              <div class="col-12 f18 uppercase el1 pr10"><span class="fr" @click="go_store_select()" v-if="$store.state.pos.pos_count > 1"><i class="iconfont icon-qiehuan- color-warning"></i></span> {{ $store.state.pos.enterprise_name }} </div>
              <div class="col-12 f12 mt2 color-warning fw"> {{ $store.state.pos.plan_name }} </div>
            </div>
          </div>
          <div class="col-12 pl10 pr10 color-black" style="position:absolute;top: 8rem;">
            <div class="col-12 bg-color-white r5 pt5 pb5 pl5 pr5">
              <div class="col-12 fw f14 bb1 color-black">
                <div class="col-9 uppercase pt5 pb10">Resumen de <span class="ml3 bg-color-primary color-white pl8 pr8 pt5 pb5 r5 f12">hoy</span></div>
                <div class="col-3 t-r lh24 f12 uppercase">
                  <div class="col-6 t-c rtl5 rbl5" :class="$store.state.pos.currency_on == 0 ? 'bg-color-primary color-white' : 'bg-color1 color-muted'" @click="currencyOn(0)">Bs</div>
                  <div class="col-6 t-c rtr5 rbr5" :class="$store.state.pos.currency_on == 1 ? 'bg-color-primary color-white' : 'bg-color1 color-muted'" @click="currencyOn(1)">$</div>
                </div>
              </div>
              <div class="col-12 pt8 pb8 color-muted">
                <div class="col-4 t-c br1">
                  <div class="col-12 f22 color-black fw">{{ sales_count }}</div>
                  <div class="col-12 f14 pt3">Ventas</div>
                </div>
                <div class="col-4 t-c br1">
                  <div class="col-12 f22 color-black fw"><div v-html="formatMoney(sales_total_ex1)" v-if="$store.state.pos.currency_on == 1"></div> <div v-html="formatMoney(sales_total)" v-else></div> </div>
                  <div class="col-12 f14 pt3">Total({{ $store.state.currency[$store.state.pos.currency_on].currency_code }})</div>
                </div>
                <div class="col-4 t-c">
                  <div class="col-12 f22 color-black fw"><div v-html="formatMoney(sales_profit_ex1)" v-if="$store.state.pos.currency_on == 1"></div> <div v-html="formatMoney(sales_profit)" v-else></div> </div>
                  <div class="col-12 f14 pt3">Ganancia({{ $store.state.currency[$store.state.pos.currency_on].currency_code }})</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="h4"></div>
        <div class="col-12 pt5 pb10 pl10 pr10 f14 fw uppercase"><i class="iconfont icon-arrow-right-filling color-primary"></i> Funciones</div>
        <div class="col-12 pl10 pr10">
          <div class="col-4 pl5 pr5" @click="go_scan()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-iconfontscan"></i></div>
              <div class="col-12 f14 color-white">Escanear</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="go_dy_password()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-lock"></i></div>
              <div class="col-12 f14 color-white">Autorización</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="go_warehouseProducts()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-kucun-xianxing"></i></div>
              <div class="col-12 f14 color-white">Almacén</div>
            </div>
          </div>
        </div>
        <div class="col-12 pl10 pr10 pt5">
          <div class="col-4 pl5 pr5" @click="go_clients()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-members"></i></div>
              <div class="col-12 f14 color-white">Clientes</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="go_products()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-chanpin"></i></div>
              <div class="col-12 f14 color-white">Productos</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="go_m_warehouseProducts()">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-cangku_cangchuguanli"></i></div>
              <div class="col-12 f14 color-white">Almacenes</div>
            </div>
          </div>
        </div>
        <div class="col-12 pl10 pr10 pt5">
          <div class="col-4 pl5 pr5" @click="go_page('M_Setting')">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"><i class="iconfont icon-set"></i></div>
              <div class="col-12 f14 color-white">Ajuste</div>
            </div>
          </div>
          <div class="col-4 pr5" @click="">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"></div>
              <div class="col-12 f14 color-white"></div>
            </div>
          </div>
          <div class="col-4 pr5" @click="">
            <div class="col-12 r5 h8 bg-color-primary b-s-1 t-c pt10">
              <div class="col-12 f30 color-white"></div>
              <div class="col-12 f14 color-white"></div>
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="col-12 lh40 pt5 pl10 pr10 f14 fw uppercase"><i class="iconfont icon-arrow-right-filling color-primary"></i> Últimas ventas</div>
      -->
    </div>
    <div class="h40"></div>
    <div class="h14"></div>
    <div class="col-12 pl10 pr10" style="overflow-y: auto;">
      <div class="bg-color-white" v-if="chartData.rows.length > 0">
        <ve-line :data="chartData" height="280px"></ve-line>    
      </div>
      <!--
      <div class="col-12 bg-color-white r5 p5 mb8 ho1" v-if="chartData.rows.length == 0">
        <div class="col-12 t-c color-muted f14 pt20">
          <div class="col-12"><img src="@/assets/no-data.png" class="w8"></div>
          <div class="col-12 lh30">No hay datos</div>
        </div>
      </div>
      -->
      <!--
      <div class="col-12 bg-color-white r5 p5 mb8 ho1" :class="{'bl5-primary': sale.sale_type > 0,'bl5-warning': sale.sale_type === -2,'bl5-danger': sale.sale_type === -1}" v-for="(sale, sale_i) in sales" v-bind:key="sale_i" @click="go_sale(sale.id)">
        <div class="col-8">
          <div class="col-12 f14 el1">{{ sale.client_name }} </div>
          <div class="col-12">
            <span class="fw f14">#{{ sale.sale_no }}</span> <span class="f10 color-muted">{{ sale.update_time }}</span> 
          </div>
        </div>
        <div class="col-4 f16 t-r pt10" :class="{'color-black': sale.sale_type != -1,'color-warning': sale.sale_type === -1 && sale.to_sale_id > 0,'color-danger': sale.sale_type === -1 && sale.to_sale_id === 0}">
          <span v-if="sale.sale_type == -1">-</span>
          <span class="f12">{{ $store.state.currency[$store.state.pos.currency_on].currency_code }}</span><span v-if="$store.state.pos.currency_on == 1">{{fun.formatMoney(sale.total_ex1,2,'.',',')}}</span>
          <span v-else>{{fun.formatMoney(sale.total,2,'.',',')}}</span>
        </div>
      </div>
     -->
      <div class="col-12 fixed-b pb30 t-c h10">
        <i class="iconfont icon-cloud-link-full f34" :class="{'color-success': update_timer,'color-muted': !update_timer,}"></i> <span class="color-success fw f28" v-if="update_timer">{{ update_timer }}</span><span v-if="update_timer">s</span>
      </div>
    </div> 
    <div ref="app_foot" class="col-12 fixed-b t-c color-muted f14 bg-color-white bt1 pb5 pt5">
      <div class="col-3" @click="getMainData()">
        <div class="col-12 color-primary">
          <div class="col-12 f28"><i class="iconfont icon-home"></i></div>
          <div class="col-12 f12 fw">Resumen</div>
        </div>
      </div>
      <div class="col-3" @click="go_sales()">
        <div class="col-12 color-black">
          <div class="col-12 f28"><i class="iconfont icon-list"></i></div>
          <div class="col-12 f12">Ventas</div>
        </div>
      </div>
      <div class="col-3" @click="go_report()">
        <div class="col-12 color-black">
          <div class="col-12 f28"><i class="iconfont icon-fl-baobiao"></i></div>
          <div class="col-12 f12">Reporte</div>
        </div>
      </div>
      <div class="col-3" @click="go_my()">
        <div class="col-12 color-black">
          <div class="col-12 f28"><i class="iconfont icon-31wode"></i></div>
          <div class="col-12 f12">Mi</div>
        </div>
       </div>  
    </div>
  </div>
</template>
<script>
export default {
  name: 'Main',
  data () {
    return {
      extension_list: [],
      currency: 1,
      menu_on: false,
      extension_list_h: 400,
      sales_count: 0,
      sales_total: 0,
      sales_profit: 0,
      sales_total_ex1: 0,
      sales_profit_ex1: 0,
      sales: [],
      update_timer: '',
      notify_count: 0,
      chartData: {
        columns: ["Hora","Ventas"],
        rows: [
        ]
      }
    }
  },
  created: function () {
    //初始化页面参数
    this.initPageArgs();
    //获取首页数据
    this.getMainData();
    //设置更新时间倒计时
    this.setUpDateTimer();
  },
  mounted() {
  },
  methods: {
    //获取首页数据
    getMainData: function(){
      this.post(this.api_url + 'manage/main','',true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setPos',res.data.pos);
          if(res.data.currency != ''){
            //console.log(res.data.currency)
            this.$store.commit('setCurrency',res.data.currency);
          }
          this.sales_count = res.data.sales_count;
          this.sales_total = res.data.sale_detail_total;
          this.sales_profit = res.data.sale_detail_profit;
          this.sales_total_ex1 = res.data.sale_detail_total_ex1;
          this.sales_profit_ex1 = res.data.sale_detail_profit_ex1;
          this.notify_count = res.data.notify_count;
          this.chartData.rows = res.data.sales_hour;
          //this.getSales();
          if(this.update_timer < -1){
            clearInterval(this.UpdateTimer);
          }
        }else if(res.status == 0){
          this.$router.push({name:'M_PosWait'});
          //this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }else if(res.status == -1){
          this.$router.push({name:'Login'});
        }
      })
    },
    //获取销售数据
    getSales: function(){
      this.post(this.api_url + 'manage/main_sales','',true).then((res)=>{
        if(res.status == 1){
          this.sales = res.data.sales;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //更新时间倒计时
    setUpDateTimer: function(){
      var _this = this;
      this.UpdateTimer = setInterval(function(){
        _this.update_timer = _this.$store.state.pos.interval_time - (Math.floor(Date.now() / 1000) - _this.$store.state.pos.update_time);
        //console.log( _this.update_timer)
        if(_this.update_timer == -10 || _this.update_timer == -20 || _this.update_timer == -30 || _this.update_timer == -40 || _this.update_timer == -50 || _this.update_timer == -60){
          _this.update_timer = 0
        }
        if(_this.update_timer == 0){
          _this.getMainData();
        }else if(_this.update_timer < 0){
          clearInterval(this.UpdateTimer);
          _this.update_timer = '';
        }
      }, 1000);
    },
    //切换货币
    currencyOn: function(currency){
      let post_data = {};
      post_data.currency_on = currency;
      this.post(this.api_url + 'manage/currency_change',post_data,true).then((res)=>{
        if(res.status == 1){
          this.getMainData();
        }
      })
    },
    //进入客户列表页面
    go_clients:function(){
      this.$router.push({name:'M_ClientsList'});
    },
    //进入产品列表页面
    go_products:function(){
      this.$router.push({name:'M_ProductsList'});
    },
    //进入仓库产品列表页面
    go_warehouseProducts:function(){
      this.$router.push({name:'M_WarehouseProductsList'});
    },
    //进入多仓库产品列表页面
    go_m_warehouseProducts:function(){
      this.$router.push({name:'M_MWarehouseProductsList'});
    },
    //进入销售列表页面
    go_sales:function(){
      this.$router.push({name:'M_SalesList'});
    },
    //进入报表页面
    go_report:function(){
      this.$router.push({name:'M_Report'});
    },
    //进入个人资料
    go_my:function(){
      this.$router.push({name:'M_My'});
    },
    //进入信息列表
    go_news:function(){
      this.$router.push({name:'M_News'});
    },
    //进入销售详情页
    go_sale:function(id){
      this.$router.push({name:'M_Sale',query:{id:id}});
    },
    //进入店铺选择页面
    go_store_select:function(){
      this.$router.push({name:'M_StoreSelect'});
    },
    //进入扫描页面
    go_scan:function(){
      this.$router.push({name:'Qrcode'});
    },
    //进入动态密码页面
    go_dy_password:function(){
      this.$router.push({name:'Dypassword'});
    },
    formatMoney:function (amount) {
      var amount = Number(amount).toFixed(2);
      var parts = amount.split(".");
      // 如果没有小数部分，添加 .00
      if (parts.length < 2) {
          parts.push("00");
      }
      var formattedIntPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // 返回格式化的金额，其中小数部分使用了较小的字体
      return formattedIntPart + "." + "<span class='f14'>" + parts[1] + "</span>";
    },
    //进入页面
    go_page:function(page){
      this.$router.push({name:page});
    },
    //初始化页面参数
    initPageArgs: function(){
      this.$store.commit('setAppArgs',{});
      this.$store.commit('setPageCateArgs',{cate_id:0,cate_name:''});
      this.$store.commit('setPageExtArgs',{ext_id:0,ext_name:''});
      this.$store.commit('setPageCashierArgs',{cashier_id:0,cashier_name:''});
      this.$store.commit('setPageSalesmanArgs',{salesman_id:0,sales_name:''});
    },
    //APP选择页面
    app_select: function(){
      this.$router.push({name:'AppSelect'});
    },
  },
  beforeDestroy() {
    clearInterval(this.UpdateTimer);
  }
}
</script>
<style scoped>
@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-2px); }
  50% { transform: translateX(2px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}
.shake {
  animation: shake 0.5s infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/Main.vue